import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';

export const hasPasswordTokenGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  return route.queryParamMap.has('password-token') ? true : router.parseUrl('/');
};
